var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    _vm._l(_vm.dashItems, function(item, index) {
      return _c("div", { staticClass: "dash-card" }, [
        _c(
          "div",
          { staticClass: "rectangle" },
          [
            [
              _c("router-link", { attrs: { to: item.url } }, [
                _c(
                  "div",
                  {
                    staticClass: "borderRadius",
                    style: { backgroundColor: item.color }
                  },
                  [
                    _c("div", { staticClass: "paddingTop5px" }, [
                      _c(
                        "a",
                        {
                          staticClass: " header-card alignTextMarginLeft",
                          attrs: { href: item.url }
                        },
                        [_vm._v(_vm._s(item.name))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div")
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dash-card-content" }, [
                  _c("div", { staticClass: "paddingTop7px" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "content-dashboard-card alignTextMarginLeft",
                        attrs: { href: item.url }
                      },
                      [_vm._v(_vm._s(item.description))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dash-card-number" }, [
                    _vm._v(_vm._s(_vm.countEventByStatus(item.eventStatus)))
                  ])
                ])
              ])
            ]
          ],
          2
        )
      ])
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22bba277", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bba277","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashCards.vue
// module id = 1280
// module chunks = 1